namespace GeniuzPOS.Lookups {
    export namespace VwpsShopGroupService {
        export const baseUrl = 'Lookups/VwpsShopGroup';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwpsShopGroupRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwpsShopGroupRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwpsShopGroup/Retrieve",
            List = "Lookups/VwpsShopGroup/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwpsShopGroupService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
